import React from 'react';

type Tone = 'info' | 'warning';

interface SettingsNoteProps {
  children: React.ReactNode;
  tone?: Tone;
}

export const SettingsNote: React.FC<SettingsNoteProps> = ({ children, tone = 'info' }) => (
  <div className={`kx-settings-note kx-settings-note--${tone}`}>{children}</div>
);

export default SettingsNote;
